module.exports = __webpack_public_path__ + "img/摄图网_500574440_banner_云计算（非企业商用）.81bcfcad.png";